var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformationBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4682_224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.59425 0 0 3.59425 0 8C0 12.4057 3.59425 16 8 16C12.4058 16 16 12.4057 16 8C16 3.59425 12.4058 0 8 0ZM9.10168 10.8992L8.34805 11.1891L9.21763 6.66733C9.2756 6.43544 9.15966 6.20355 8.98574 6.02965C8.81183 5.91371 8.52197 5.85574 8.34807 5.97168L6.72487 6.89921C6.43502 7.07312 6.31907 7.42096 6.49298 7.71081C6.6669 8.00066 7.01473 8.11661 7.30458 7.94269L7.76836 7.65284L6.89878 12.0006C6.84081 12.2325 6.95675 12.4644 7.13067 12.5803C7.24661 12.6962 7.36255 12.6962 7.53647 12.6962C7.59444 12.6962 7.71038 12.6962 7.76835 12.6383L9.56545 11.8846C9.8553 11.7687 10.0292 11.3629 9.8553 11.073C9.73936 10.8991 9.39153 10.7252 9.10168 10.8991V10.8992ZM9.27565 4.52063C9.10175 4.63657 8.86986 4.75251 8.63798 4.75251C8.4061 4.75251 8.23219 4.69454 8.0003 4.52063C7.88436 4.34673 7.76842 4.11483 7.76842 3.88295C7.76842 3.65108 7.82639 3.41919 8.0003 3.24528C8.1742 3.12934 8.40609 3.01339 8.63798 3.01339C8.86985 3.01339 9.10174 3.07137 9.27565 3.24528C9.39159 3.41918 9.50754 3.65108 9.50754 3.88295C9.50754 4.11483 9.44956 4.34672 9.27565 4.52063Z",
    fill: "#032146"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4682_224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationBlue);
export default __webpack_public_path__ + "static/media/informationBlue.b80d667abb6917fae6a751c13d975a7e.svg";
export { ForwardRef as ReactComponent };